import React from "react";
import { Outlet } from "react-router-dom";
import Header from "./header";
import Footer from "./footer";


const CareerLayout = () => {
  return (
    <>
      <Header />
      <main className="w-full mx-auto sm:max-w-[640px] md:max-w-[768px] lg:max-w-[1024px] xl:max-w-[1280px] 2xl:max-w-[1536px] px-4">
        <Outlet />
      </main>
      <Footer />
    </>
  );
};

export default CareerLayout;
